<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="pageTitle"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div v-if="canManageCertificates" class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("add") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <certificate-list-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :type="pageType"
      @close-modal="closeAddEditModal"
    />

    <certificate-description-modal
      v-if="isDescriptionModalActive"
      :detail="descriptionDetail"
      @close-modal="closeDescriptionModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "@/core/helpers/app/AppFunction";
import CertificateDescriptionModal from "../../Client/Buyer/Certificate/CertificateDescriptionModal.vue";

export default {
  extends: CoreLibrary,
  name: "CertificateListings",
  mixins: [TableHelpers],
  components: {
    CertificateDescriptionModal,
  },

  data() {
    return {
      id:'',
      isDescriptionModalActive: false,
      descriptionDetail: {},
      isViewModalActive: false,
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        url: actions.CERTIFICATE_LIST+'?type='+ this.$attrs['type'],
        name: this.$t("certificate_list"),
        datatableWrapper: true,
        showHeader: true,
        columns: [
          {
            title: this.$t('title'),
            type: 'media-object',
            key: 'media-object',
            mediaTitleKey: 'title',
            // mediaSubtitleKey: 'amount',
            default: AppFunction.getAppUrl('images/bannerlayout.png'),
            modifier: (value, row) => {
              return AppFunction.getAppUrl(row.logo ?? 'images/bannerlayout.png'); // imag url
            },
            isVisible: true
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value, row) => {
              const triggerId = `course-description-${row.id}`;
              this.bindDescriptionTrigger(triggerId, row);
              return `<button type="button" id="${triggerId}" class="btn btn-link p-0">${this.$t("view")}</button>`;
            },
          },
          {
            title: this.$t("category"),
            type: "custom-html",
            key: "category",
            modifier: (value) => {
              return `<span>${value ? this.$t(value.category_name) : '---'}</span>`;
            },
          },
          {
            title: this.$t("forms"),
            type: "custom-html",
            key: "forms",
            modifier: (value) => {
              return `<span>${this.formatFormsCount(value)}</span>`;
            },
          },
          {
            title: this.$t("pricing"),
            type: "custom-html",
            key: "pricing_type",
            isVisible: this.$attrs['type'] === 'course_management',
            modifier: (value, row) => {
              return `<span>${row.pricing_type === 'credit_based' ? `${row.credit_usage} Credits` : 'Free'}</span>`;
            },
          },
          {
            title: this.$t("Issue mode"),
            type: "custom-html",
            key: "issuance_mode",
            isVisible: this.$attrs['type'] === 'course_management',
            modifier: (value) => {
              return `<span class="text-capitalize">${(value || 'manual').replace('_', ' ')}</span>`;
            },
          },
          {
            title: this.$t("Expiry days"),
            type: "custom-html",
            key: "expire_day",
            modifier: (value) => {
              return `<span>${value || '---'}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          },
        ],
         filters: [
        //   {
        //     title: this.$t("date"),
        //     type: "range-picker",
        //     key: "date",
        //     option: ["today", "thisMonth", "last7Days", "nextYear"],
        //   },
        //   {
        //     title: this.$t("priority"),
        //     type: "checkbox",
        //     key: "priority",
        //     option: [
        //       { id: "low", value: "Low" },
        //       { id: "medium", value: "Medium" },
        //       { id: "high", value: "High" },
        //     ],
        //   },
        //   {
        //     title: this.$t("status"),
        //     type: "checkbox",
        //     key: "status",
        //     option: [
        //       { id: "completed", value: "Completed" },
        //       { id: "incomplete", value: "Incomplete" },
        //       // {id: 'invited', value: 'Invited'},
        //     ],
        //   },
          {
              "title": this.$t('search_and_select'),
              "type": "drop-down-filter",
              "key": "search select",
              "option": [],
          }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  computed:{
    pageTitle(){
      return this.$attrs['page-title']
    },
    pageType(){
      return this.$attrs['type']
    },
    canManageCertificates() {
      return this.$store.state.user.loggedInUser.company_id === 1;
    },
  },
  created() {
    if (this.canManageCertificates) {
      this.options.columns = [...this.options.columns, this.actionObj];
    }
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#certificate-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    openViewModal() {
      this.isViewModalActive = true;
    },
    closeViewModal() {
      $("#demo-view-Modal").modal("hide");
      this.isViewModalActive = false;
    },
    closeDescriptionModal() {
      $("#certificate-description-modal").modal("hide");
      this.isDescriptionModalActive = false;
      this.descriptionDetail = {};
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.CERTIFICATE_SHOW}/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.CERTIFICATE_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    openDescriptionModal(rowData) {
      this.descriptionDetail = rowData;
      this.isDescriptionModalActive = true;
    },
    bindDescriptionTrigger(triggerId, row) {
      setTimeout(() => {
        const trigger = document.getElementById(triggerId);
        if (trigger && !trigger.dataset.descriptionBound) {
          trigger.dataset.descriptionBound = "true";
          trigger.addEventListener("click", (event) => {
            event.preventDefault();
            this.openDescriptionModal(row);
          });
        }
      }, 0);
    },
    formatFormsCount(value) {
      if (!value) {
        return '---';
      }

      const forms = Array.isArray(value) ? value : value.toString().split(',').filter(Boolean);
      return `${forms.length} ${forms.length === 1 ? this.$t('form') : this.$t('forms')}`;
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CERTIFICATE_CATEGORY_GET).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.value,
            value: name.value,
          };
        });
      });
    },
  },
};
</script>
